import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { visitSettlementTranslationKeys } from '../../../translations';

const t = visitSettlementTranslationKeys.shared.form.priceChangeReason.textView;

const StyledPlaceholderText = styled.span`
   color: ${(props) => props.theme.placeholder};
`;

StyledPlaceholderText.displayName = 'StyledPlaceholderText';

type PriceChangeReasonTextViewProps = {
   readonly value: string | null;
};

export const PriceChangeReasonTextView = (props: PriceChangeReasonTextViewProps): JSX.Element => {
   return (
      <TextView label={t.label} testId={'priceChangeReason'}>
         {props.value ?? (
            <StyledPlaceholderText>
               <Translate>{t.placeholder}</Translate>
            </StyledPlaceholderText>
         )}
      </TextView>
   );
};
